/*
    * Functions that commit mutations. The main difference to Mutations is that Actions can contain asynchronous operations
*/
import { ActionTree } from "vuex";
import { RootState } from "../../../../types";
import { About } from "./types";

/*
    * Used for changing the state or data
*/
export const actions: ActionTree<About, RootState> = {
    /*
        * Dialog close event
    */
    _aboutDialogClose({ commit }, payload) {
        commit("_aboutDialogClose", payload);
    }
};
